import Client from './Client';
import Error from './Error';

export default class Api extends Client {
  static async login(token: string, secret: string) {
    try {
      return await Api.request(null, 'post', 'oauth', { token, secret }, null);
    } catch (error) {
      throw new Error(error);
    }
  }

  static async initTemplate(token: string, templateId: number, body: any) {
    try {
      return await Api.request(token, 'put', `template/${templateId}`, body, null);
    } catch (error) {
      throw new Error(error);
    }
  }

  static async sendMission(token: string, body: any) {
    try {
      return await Api.request(token, 'put', 'mission', body, null);
    } catch (error) {
      throw new Error(error);
    }
  }
}
